import { EAssetType } from '../models/products/asset';

export type ReviewableAssetType = EAssetType.SHOOT_ASSETS | EAssetType.POST_ASSETS;

type AssetGroupMethods = {
  Review: string;
  Comment: string;
};

// Asset-specific groups (id + optional channel)
export const SignalRAssetGroups: Record<ReviewableAssetType, AssetGroupMethods> = {
  [EAssetType.SHOOT_ASSETS]: {
    Review: 'JoinShootAssetReviewGroup',
    Comment: 'JoinShootAssetCommentGroup',
  },
  [EAssetType.POST_ASSETS]: {
    Review: 'JoinPostAssetReviewGroup',
    Comment: 'JoinPostAssetCommentGroup',
  },
};

// Static groups (no params)
export const SignalRStaticGroups = {
  ProductsShot: 'JoinProductsShotGroup',
  ProductsEnhanced: 'JoinProductsEnhancedGroup',
  ProductsReviewed: 'JoinProductsReviewedGroup',
  UsersList: 'JoinUsersListGroup',
  BatchesList: 'JoinBatchesListGroup',
  OrganizationsList: 'JoinOrganizationsListGroup',
} as const;

// Id groups (takes id param)
export const SignalRIdGroups = {
  MasterSuitesList: 'JoinMasterSuitesListGroup',
  SettingsList: 'JoinSettingsListGroup',
  PackagesList: 'JoinPackagesListGroup',
  ProductDetails: 'JoinProductDetailsGroup',
  ProductsList: 'JoinProductsListGroup',
  BatchDetails: 'JoinBatchDetailsGroup',
  ProductShootAssets: 'JoinProductShootAssetsGroup',
  ProductPostAssets: 'JoinProductPostAssetsGroup',
} as const;
